<!--  -->
<template>
  <div class="wrapper">
    <div class="downloads">
      <div class="download-search-container">
        <ul>
          <li class="download-search-item">
            <dl class="download-search-item-dl">
              <dt class="download-search-item-dt">Taxon Search</dt>
              <dd class="download-search-item-dd">
                <div class="download-search-input">
                  <el-input
                    v-model.trim="taxon.taxon_name"
                    placeholder="Taxon Name"
                  ></el-input>
                </div>
              </dd>
            </dl>
          </li>
          <!-- <li class="download-search-item">
            <dl class="download-search-item-dl">
              <dt class="download-search-item-dt">Literature Search</dt>
              <dd class="download-search-item-dd">
                <div class="download-search-input">
                  <el-input v-model="literature.title" placeholder="Title"></el-input>
                  <el-input v-model="literature.author" placeholder="Author"></el-input>
                  <el-input v-model="literature.year" placeholder="Year"></el-input>
                  <el-input v-model="literature.publication" placeholder="Publication"></el-input>
                  <el-input v-model="literature.doi" placeholder="Doi"></el-input>
                </div>
              </dd>
            </dl>
          </li> -->
          <li class="download-search-item">
            <dl class="download-search-item-dl">
              <dt class="download-search-item-dt">GPS Search</dt>
              <dd class="download-search-item-dd">
                <div class="download-search-input">
                  <dl>
                    <dt>Longitude Scope</dt>
                    <dd>
                      <el-input
                        v-model="gps.longitudemin"
                        placeholder="Min"
                      ></el-input>
                      <div class="connect-line">-</div>
                      <el-input
                        v-model="gps.longitudemax"
                        placeholder="Max"
                      ></el-input>
                    </dd>
                  </dl>
                  <dl>
                    <dt>Latitude Scope</dt>
                    <dd>
                      <el-input
                        v-model="gps.latitudemin"
                        placeholder="Min"
                      ></el-input>
                      <div class="connect-line">-</div>
                      <el-input
                        v-model="gps.latitudemax"
                        placeholder="Max"
                      ></el-input>
                    </dd>
                  </dl>
                </div>
              </dd>
            </dl>
          </li>
          <li class="download-search-item">
            <dl class="download-search-item-dl">
              <dt class="download-search-item-dt">Specimen Time</dt>
              <dd class="download-search-item-dd">
                <div class="download-search-input">
                  <el-input
                    v-model.trim="specimen_time.system"
                    placeholder="System"
                  ></el-input>
                  <el-input
                    v-model.trim="specimen_time.series"
                    placeholder="Series"
                  ></el-input>
                  <el-input
                    v-model.trim="specimen_time.stage"
                    placeholder="Stage"
                  ></el-input>
                </div>
              </dd>
            </dl>
          </li>
          <li class="download-search-item">
            <dl class="download-search-item-dl">
              <dt class="download-search-item-dt">Specimen bed</dt>
              <dd class="download-search-item-dd">
                <div class="download-search-input">
                  <el-input
                    v-model.trim="specimen_bed.group"
                    placeholder="Group"
                  ></el-input>
                  <el-input
                    v-model.trim="specimen_bed.formation"
                    placeholder="Formation"
                  ></el-input>
                  <el-input
                    v-model.trim="specimen_bed.member"
                    placeholder="Member"
                  ></el-input>
                  <el-input
                    v-model.trim="specimen_bed.bed"
                    placeholder="Bed"
                  ></el-input>
                </div>
              </dd>
            </dl>
          </li>
        </ul>
        <div class="contain-child">
          <el-checkbox v-model="isContainChild"> include sub-taxa </el-checkbox>
          <el-input
            @input="changeEmail"
            v-if="isContainChild"
            v-model="email"
            placeholder="Please leave an email. We will send the results to you when we finish packing data."
          ></el-input>
        </div>
        <p class="error" v-if="submitErr">
          Please enter the correct email address
        </p>
        <div class="download-search-buttons">
          <el-button
            v-if="isContainChild"
            type="primary"
            class="search-btn"
            @click="submit"
            >Submit</el-button
          >
          <el-button
            v-else
            type="primary"
            class="search-btn download-search-btn"
            icon="el-icon-download"
            @click="download"
          >
            Download</el-button
          >
          <!-- <el-button v-else type="primary" class="search-btn download-search-btn" icon="el-icon-search" @click="search"> Search</el-button> -->
          <el-button
            type="primary"
            class="reset-btn download-search-reset-btn"
            icon="el-icon-refresh-right"
            @click="reset"
            >Reset</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { download, postToEmail, utlogMap } from "@/api/index";
import { functionId } from "@/utils/browser.js";
import { mixins } from "@/mixins/index";
export default {
  mixins: [mixins],
  name: "download",
  data() {
    return {
      submitErr: false,
      isContainChild: true,
      email: "",
      taxon: {
        taxon_name: "",
      },
      literature: {
        title: "",
        author: "",
        year: "",
        publication: "",
        doi: "",
      },
      gps: {
        longitudemin: "",
        longitudemax: "",
        latitudemin: "",
        latitudemax: "",
      },
      specimen_time: {
        system: "",
        series: "",
        stage: "",
      },
      specimen_bed: {
        group: "",
        formation: "",
        member: "",
        bed: "",
      },
    };
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {},
  methods: {
    changeEmail() {
      this.submitErr = false;
    },
    hasNullValue(object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          const element = object[key];
          if (element && element.length <= 2) {
            this.error("查询条件" + key + "字符较短");
            return true;
          }
        }
      }
    },
    search() {
      if (this.hasNullValue(this.taxon)) return;
      if (this.hasNullValue(this.gps)) return;
      if (this.hasNullValue(this.specimen_time)) return;
      if (this.hasNullValue(this.specimen_bed)) return;
      this.$router.push({
        name: "DownloadList",
        query: {
          ...this.taxon,
          ...this.gps,
          ...this.specimen_time,
          ...this.specimen_bed,
        },
      });
    },
    submit() {
      if (this.hasNullValue(this.taxon)) return;
      if (this.hasNullValue(this.gps)) return;
      if (this.hasNullValue(this.specimen_time)) return;
      if (this.hasNullValue(this.specimen_bed)) return;
      var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (reg.test(this.email)) {
        const query = {
          ...this.taxon,
          ...this.gps,
          ...this.specimen_time,
          ...this.specimen_bed,
          email: this.email,
        };
        postToEmail(query).then((res) => {
          if (res.data.success) {
            // alert('Please view your mailbox')
            const message = `Submission successful! The server has received your data request and will later send the packaged data link to the email address <b style="color:red">${this.email}</b>. The packaging time of the data depends on the amount of data, so please wait and check your email later. Please do not submit repeatedly.`;
            this.$message({
              duration: 0,
              type: "success",
              message: message,
              showClose: true,
              dangerouslyUseHTMLString: true,
            });
            this.email = "";
          } else {
            this.submitErr = true;
            // this.$message.error('Maybe the task you submitted previously has not been completed')
          }
        });
        let logMap = {
          eventType: "clk",
          url: window.location.href,
          functionId: 'Deepbone_download_emailSubmit',
          utlogMap: {
            keywords: {
              ...this.taxon,
              ...this.gps,
              ...this.specimen_time,
              ...this.specimen_bed,
              email: this.email,
            },
          },
        };
        utlogMap(logMap).then((res) => {
        //   console.log(res);
        });
      } else {
        // this.$message.error('Please enter the correct email address')
        this.submitErr = true;
      }
    },
    download() {
      if (this.hasNullValue(this.taxon)) return;
      if (this.hasNullValue(this.gps)) return;
      if (this.hasNullValue(this.specimen_time)) return;
      if (this.hasNullValue(this.specimen_bed)) return;
      this.$bus.$emit("loading", true, "Downloading...");
      const query = {
        ...this.taxon,
        // ...this.literature,
        ...this.gps,
        ...this.specimen_time,
        ...this.specimen_bed,
      };
      download(query)
        .then((res) => {
          if (res.status == 200 && res.headers["content-disposition"]) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const fileName = decodeURI(
              res.headers["content-disposition"].split(";")[1].split("=")[1]
            );
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.$bus.$emit("loading", "success", "success");
          } else {
            this.$bus.$emit("loading", "error", "error");
          }
        })
        .finally((e) => {
          setTimeout(() => {
            this.$bus.$emit("loading", false);
          }, 1000);
          let logMap = {
            eventType: "download",
            url: window.location.href,
            functionId: 'Deepbone_download_download',
            utlogMap: {
              keywords: {
                ...this.taxon,
                ...this.gps,
                ...this.specimen_time,
                ...this.specimen_bed,
                email: this.email,
              },
            },
          };
          utlogMap(logMap).then((res) => {
            // console.log(res);
          });
        });
    },
    reset() {
      this.taxon = {
        taxon_name: "",
      };
      //   this.literature = {
      //     title: "",
      //     author: "",
      //     year: "",
      //     publication: "",
      //     doi: "",
      //   };
      this.gps = {
        longitudemin: "",
        longitudemax: "",
        latitudemin: "",
        latitudemax: "",
      };
      this.specimen_time = {
        system: "",
        series: "",
        stage: "",
      };
      this.specimen_bed = {
        group: "",
        formation: "",
        member: "",
        bed: "",
      };
      this.email = "";
      this.submitErr = false;
      let logMap = {
          eventType: "clk",
          url: window.location.href,
          functionId: 'Deepbone_download_reset'
        };
        utlogMap(logMap).then((res) => {
        //   console.log(res);
        });
    },
  },
  // 生命周期 - 挂载完成（访问DOM元素）
};
</script>
<style>
.downloads {
  width: 100%;
  overflow: hidden;
}
.download-search-container,
.download-search-container ul {
  width: 100%;
}
.download-search-item {
  margin-bottom: 20px;
}
.download-search-item:last-child {
  margin-bottom: 0;
}
.download-search-item-dl {
}
.error {
  padding-left: 176px;
  color: red;
}
/* .contain-child .el-checkbox__label, */
.download-search-item-dt {
  /* height: 38px; */
  font-weight: 500;
  font-size: 16px;
  /* line-height: 38px; */
  color: #484d63;
  margin-bottom: 12px;
  overflow: hidden;
}
.contain-child .el-checkbox__inner {
  width: 16px;
  height: 16px;
}
.contain-child .el-checkbox__label {
  font-size: 16px;
  color: #484d63;
}
.contain-child .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #72c2c9;
}
.contain-child .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #72c2c9;
  border-color: #72c2c9;
}
.download-search-item-dd {
}
.download-search-input {
  width: 100%;
  overflow: hidden;
}
.download-search-input .el-input {
  width: 32%;
  float: left;
  margin-right: 2%;
  margin-bottom: 12px;
}
.contain-child .el-input .el-input__inner,
.download-search-input .el-input .el-input__inner {
  height: 35px;
  padding: 0 12px;
  border: 2px solid #efefef;
  box-sizing: border-box;
}
.download-search-input .el-input:nth-child(3n) {
  margin-right: 0;
}
.download-search-input dt,
.download-search-input dd {
  float: left;
  /* height: 35px; */
}
.download-search-input dt {
  width: 170px;
  vertical-align: middle;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 35px;
  color: #484d63;
}
.download-search-input dd {
  width: calc(100% - 170px);
  /* vertical-align: middle; */
}
.download-search-input dd .el-input {
  width: 25%;
}
.download-search-input dd > div {
  float: left;
}
.connect-line {
  width: 5px;
  height: 35px;
  line-height: 38px;
  color: #484d63;
  margin-right: 2%;
}
.download-search-buttons {
  padding: 20px 0;
  text-align: right;
}
.download-search-buttons .el-button {
  width: 133px;
  height: 35px;
}
.download-btn,
.download-btn:hover,
.download-btn:focus {
  background-image: url("../../assets/images/download.png");
  background-repeat: no-repeat;
  background-size: 15px 14px;
  background-position: 12px 10px;
}

.contain-child {
  display: flex;
  flex-direction: row;
  height: 50px;
  line-height: 50px;
}
.contain-child .el-input {
  width: 50%;
  margin-left: 20px;
}
.contain-child > label {
  vertical-align: middle;
}
</style>
